import script from "./ArticleVariationsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleVariationsModal.vue?vue&type=script&setup=true&lang=js"

import "./ArticleVariationsModal.vue?vue&type=style&index=0&id=03d07a97&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d07a97"]])

export default __exports__